import React, {useCallback, useEffect, useRef, useState} from 'react';
import ImageUpload from '../../resources/icon/img-upload.png'
import UploadHere from '../../resources/icon/upload.png'
import Forbidden from '../../resources/icon/forbidden.png'

/**
 * `이미지업로더 `이미지
 * */


function ImageUploader({className, filed}) {

    // 드래그 중일때와 아닐때의 스타일을 구분하기 위한 state 변수
    const [isDragging, setIsDragging] = useState(false);
    const [dragIn, setDragIn]=useState(false);
    // 각 선택했던 파일들의 고유값 id
    const fileId = useRef(0);
    // 드래그 이벤트를 감지하는 ref 참조변수 (label 태그에 들어갈 예정)
    const dragRef = useRef(null);

    const onChangeFiles = useCallback((e) => {
        let selectFiles = [];
        if (e.type === "drop") {
            // 드래그 앤 드롭 했을 때
            selectFiles = Array.from(e.dataTransfer.files);
        } else {
            // "파일 첨부" 버튼을 눌러서 이미지를 선택했을 때
            selectFiles = Array.from(e.target.files);
            console.log(e.target.files[0])
        }

        const prevFiles = [...filed.files];
        const newFiles = [];

        let loaded = 0;

        if (selectFiles.length === 0) return;

        selectFiles.forEach((file, idx) => {
            const id = fileId.current++;

            if (file.type.startsWith('image/')) {
                const reader = new FileReader();
                reader.onload = (event) => {
                    const previewImage = event.target.result;
                    newFiles[idx] = {
                        id,
                        object: file,
                        previewImage,
                    };

                    loaded++;
                    // 모든 파일 로드가 끝나면 한 번에 setState 하기
                    if (loaded === selectFiles.length) {
                        filed.setFiles([...prevFiles, ...newFiles]);
                    }
                };
                reader.readAsDataURL(file);
            } else {
                alert("이미지만 첨부할 수 있습니다.")
                // tempFiles.push({
                //     id,
                //     object: file,
                // });
                // filed.setFiles(tempFiles);
                // setPreviewImages(newPreviewImages);
            }
        }
    )}, [filed.files, filed.setFiles]);

    const handleDeleteImage = (id) => {
        // 이미지 삭제 처리
        // 파일 목록에서도 해당 이미지를 제거
        const newFiles = filed.files.filter((file) => file.id !== id);
        filed.setFiles(newFiles);
    };
    const handleFileInputChange = (e) => {
        // 드래그 앤 드롭이 아닌 경우에만 파일 목록 처리
        if (!isDragging) {
            onChangeFiles(e);
            e.target.value = null; // 추가: 같은 파일 재업로드 허용
        }
    };
    const handleDragIn = useCallback((e) => {
        e.preventDefault();
        e.stopPropagation();
        setIsDragging(true);
        setDragIn(true);
    }, []);

    const handleDragOut = useCallback((e) => {
        e.preventDefault();
        e.stopPropagation();
        setIsDragging(false);
        setDragIn(false);
    }, []);

    const handleDragOver = useCallback((e) => {
        e.preventDefault();
        e.stopPropagation();
        if (e.dataTransfer?.files.length > 0) {
            setIsDragging(true);
        } else {
            setIsDragging(false);
        }
    }, []);

    const handleDrop = useCallback((e) => {
        e.preventDefault();
        e.stopPropagation();
        if (e.dataTransfer?.files.length > 0) {
            setIsDragging(false);
            setDragIn(false);
            onChangeFiles(e);
        }
    }, [onChangeFiles]);



    const initDragEvents = useCallback(() => {
        if (dragRef.current !== null) {
            dragRef.current.addEventListener("dragenter", handleDragIn);
            dragRef.current.addEventListener("dragleave", handleDragOut);
            dragRef.current.addEventListener("dragover", handleDragOver);
            dragRef.current.addEventListener("drop", handleDrop);
        }
    }, [handleDragIn, handleDragOut, handleDragOver, handleDrop]);

    const resetDragEvents = useCallback(() => {
        // 앞서 말했던 4개의 이벤트에 Listener를 삭제합니다. (언마운트 될때)
        if (dragRef.current !== null) {
            dragRef.current.removeEventListener("dragenter", handleDragIn);
            dragRef.current.removeEventListener("dragleave", handleDragOut);
            dragRef.current.removeEventListener("dragover", handleDragOver);
            dragRef.current.removeEventListener("drop", handleDrop);
        }
    }, [handleDragIn, handleDragOut, handleDragOver, handleDrop]);

    useEffect(() => {
        initDragEvents();

        return () => resetDragEvents();
    }, [initDragEvents, resetDragEvents]);

    return (
        <div className={`w-full relative ${className}`}>
            <div
                ref={dragRef}
                className={`print-image-container b-gray upload-h ${isDragging ? "DragDrop-File-Dragging" : "DragDrop-File"}`}
            >


                {dragIn ?
                    (<>

                        <img src={UploadHere} className="w-[50px] inline-block mt-4 mb-4 drag-drop-img "/>
                        <span className=" c-gray drag-drop-txt">여기에 놓으세요</span>
                    </>):(<>
                        {filed.files.map((file) => (
                            <div className="uploaded-img mt-[20px]" key={file.id}>
                                <div className="delete-image"
                                     onClick={() => handleDeleteImage(file.id)}>
                                    <img src={Forbidden} />
                                </div>
                                <img src={file.previewImage} className="" />
                            </div>
                        ))}
                        <img src={ImageUpload} className="w-[50px] inline-block mt-4 mb-4 drag-drop-img"/>
                        <span className=" c-gray drag-drop-txt">파일을 끌어서 놓으세요</span>
                    </>)}

            </div>
            <div className="py-3 bg-basic h-[40px]">
                <label  className="file-from-my px-6 py-1 b-gray bg-white item-center"
                        htmlFor={"file_img"}>
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" className="w-4 h-4 inline-block mr-2" >
                        <path
                            d="M9.25 13.25a.75.75 0 0 0 1.5 0V4.636l2.955 3.129a.75.75 0 0 0 1.09-1.03l-4.25-4.5a.75.75 0 0 0-1.09 0l-4.25 4.5a.75.75 0 1 0 1.09 1.03L9.25 4.636v8.614Z"/>
                        <path
                            d="M3.5 12.75a.75.75 0 0 0-1.5 0v2.5A2.75 2.75 0 0 0 4.75 18h10.5A2.75 2.75 0 0 0 18 15.25v-2.5a.75.75 0 0 0-1.5 0v2.5c0 .69-.56 1.25-1.25 1.25H4.75c-.69 0-1.25-.56-1.25-1.25v-2.5Z"/>
                    </svg>
                    <span className={'line-h-22'}>내 PC에서 파일 찾기</span>
                </label>
                <input
                    className="hidden"
                    id={"file_img"}
                    type={"file"}
                    multiple={true}
                    onChange={handleFileInputChange}
                />

            </div>
        </div>
    );
}

export default ImageUploader;
